import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <p className="font-mono text-3xl font-bold text-fg-subtle">404</p>
      <h1 className="text-lg font-medium text-fg">Esta pagina no existe</h1>
      <p className="max-w-sm text-sm text-fg-muted">
        La direccion no corresponde a ninguna seccion del sistema. Puede que el modulo aun no este
        disponible en esta fase.
      </p>
      <Link
        to="/"
        className="mt-2 rounded-sm border border-line-strong bg-panel px-3 py-1.5 text-sm font-medium text-fg-body transition-colors duration-(--t-tap) hover:bg-sunken"
      >
        Volver al inicio
      </Link>
    </div>
  );
}
